/* eslint-disable max-classes-per-file */
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { IOvertimeType } from '../../models/overtime-type.model';

export class LoadOvertimeTypes {
  static readonly type = '[Overtime Type] Load overtime types via Service';
  constructor(public filter?: MainTableFilterModel) {}
}

export class LoadAllOvertimeTypes {
  static readonly type = '[Overtime Type] Load all overtime types via Service';
  constructor() {}
}

export class LoadOvertimeTypeById {
  static readonly type = '[Overtime Type] Load a single overtime type';
  constructor(public id: string) {}
}

export class CreateOvertimeType {
  static readonly type = '[Overtime Type] Create overtime type';
  constructor(public overtimeType: IOvertimeType) {}
}

export class UpdateOvertimeType {
  static readonly type = '[Overtime Type] Update overtime type';
  constructor(public overtimeType: IOvertimeType) {}
}

export class DeleteOvertimeType {
  static readonly type = '[Overtime Type] Delete overtime type';
  constructor(public id: string) {}
}

export class ClearCurrentOvertimeType {
  static readonly type = '[Overtime Type] Clear current overtime type';
}
